__turbopack_context__.v({
  "container": "advanced-sidebar-prematch-sport-module-sass-module__mIIZ6a__container",
});
